// extracted by mini-css-extract-plugin
export default {"root":"ServiceEnabled_root__kUlff","checkbox-wrapper":"ServiceEnabled_checkbox-wrapper__3tl4l"};